import { useEffect, useRef, useState } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { ApiError, apiAction } from '../lib/api';

type Status = { kind: 'working' } | { kind: 'success' } | { kind: 'error'; message: string };

export default function Verify({ onVerified }: { onVerified: () => void }) {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState<Status>({ kind: 'working' });
  const ran = useRef(false);

  useEffect(() => {
    if (!token) {
      setStatus({ kind: 'error', message: 'Missing token' });
      return;
    }
    // StrictMode fires effects twice in dev — guard so we only verify once.
    if (ran.current) return;
    ran.current = true;

    apiAction('/api/auth/verify', { token })
      .then(() => {
        setStatus({ kind: 'success' });
        onVerified();
      })
      .catch((err) => {
        const message = err instanceof ApiError ? err.message : 'Could not verify link';
        setStatus({ kind: 'error', message });
      });
  }, [token, onVerified]);

  if (status.kind === 'success') return <Navigate to="/" replace />;

  return (
    <div className="login-shell">
      <div className="card shadow-soft login-card">
        {status.kind === 'working' ? (
          <>
            <h1 className="font-display">Signing you in…</h1>
            <p className="login-sub">One moment.</p>
          </>
        ) : (
          <>
            <h1 className="font-display">Can’t sign in</h1>
            <p className="login-sub">{status.message}</p>
            <p style={{ marginTop: 16 }}>
              <a className="sec-label" href="/login">
                Try again
              </a>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
